import { TFunction } from 'i18next';

export enum SupportedErrorTypes {
  alreadyCompleted = 'completed',
  appointmentNotPossible = 'appointment-not-possible',
  canceled = 'canceled',
  closed = 'closed',
  maintenance = 'maintenance',
  noAppointmentYet = 'no-appointment-yet',
  noSignatureFound = 'signature-not-found',
  stylesheetNotFound = 'no-stylesheet',
  ticketNotFound = 'not-found',
  unexpectedError = 'unexpected-error'
}

export const knownErrorStatuses: { [key: string]: SupportedErrorTypes } = {
  'Planning On Hold': SupportedErrorTypes.noAppointmentYet,
  Closed: SupportedErrorTypes.closed,
  Canceled: SupportedErrorTypes.canceled,
};

export const getErrorTitle = (t: TFunction, errorType: string): string => {
  switch (errorType) {
    case SupportedErrorTypes.alreadyCompleted:
      return t('errorMessages:alreadyCompleted');
    case SupportedErrorTypes.appointmentNotPossible:
      return t('errorMessages:appointmentNotPossible');
    case SupportedErrorTypes.canceled:
      return t('errorMessages:canceled');
    case SupportedErrorTypes.closed:
      return t('errorMessages:closed');
    case SupportedErrorTypes.maintenance:
      return t('errorMessages:maintenance');
    case SupportedErrorTypes.noAppointmentYet:
      return t('errorMessages:noAppointmentYet');
    case SupportedErrorTypes.noSignatureFound:
      return t('errorMessages:signatureNotFound');
    case SupportedErrorTypes.stylesheetNotFound:
      return t('errorMessages:noStylesheet');
    case SupportedErrorTypes.ticketNotFound:
      return t('errorMessages:caseNotFound');
    default:
      return t('errorMessages:default');
  }
};
